<template>
    <component :is="layout">
        <router-view/>
    </component>
</template>

<script>
import apiService from 'services/api.service'
import EmptyLayout from 'layouts/EmptyLayout.vue'
import AdminpanelLayout from 'layouts/AdminpanelLayout.vue'
import MainLayout from 'layouts/MainLayout.vue'
import { langswlist } from 'lang'

export default {
    data() {
        return {
            publicPath: process.env.VUE_APP_BASE_URL,
            langswlist: langswlist,
            locale: "en",
        }
    },
    mounted(){
        let locale = this.$root.$cookies.get('sitelocale')
        if (!locale && navigator.language && langswlist[navigator.language.slice(0, 2)]) locale = navigator.language.slice(0, 2)
        if (!locale) locale = this.$root.$i18n.locale

        this.$root.$i18n.locale = locale
        this.$root.$cookies.set('sitelocale', locale,"10y")
    },
    beforeMount(){
        this.$store.dispatch('loadConfig');
    },
    computed: {
        layout() {
            return (this.$route.meta.layout || 'empty') + '-layout'
        }
    },
    components: {
        EmptyLayout, AdminpanelLayout, MainLayout
    }
}
</script>
